// extracted by mini-css-extract-plugin
module.exports = {"Text":"MultilineTextEllipses_Text__3i2v5"};